import * as React from "react";
import EditFaultCommon from "../../Editing/EditFaultCommon";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type APMFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaults: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.APMSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.APMSubmenu, columnFilter: Filter[]) => void;
};

type APMFaultsTableState = {
  isModalOpen: boolean;
};

export class APMFaultsTable extends React.Component<APMFaultsTableProps, APMFaultsTableState> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
    if (this.props.pdApi.dataActCodes === undefined) {
      this.props.pdApiActions.fetchDataActCodes();
    }
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingFaults } = this.props;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let apmFaultRows: Api.AnyFault[] = [];
    let selectedColumns: State.Column[] = [];

    apmFaultRows = pdApi.apmFaults ? pdApi.apmFaults : [];
    apmFaultRows = apmFaultRows.map(row => setFaultExtraProperties(row, pdApi));
    selectedColumns = columns["APM Faults"];
    const startingPage = mainState.lastEditedObjectId
      ? (apmFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={apmFaultRows}
            loading={isLoadingFaults}
            loadingText="Fetching APM faults..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isFaultSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view dimmer page"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <EditFaultCommon toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /**
   * Returns status if fault has been selected
   * @param {Api.Fault} fault
   * @returns {boolean}
   */
  private isFaultSelected = (fault: Api.AnyFault): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && fault.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default APMFaultsTable;
